import {
    useQuery,
  } from '@tanstack/react-query'
  import api  from '../../services/api';

  export const useViewBarGraphQuery = (options = {}) => {
    const { enabled = true } = options;

    return useQuery({
      queryKey: ['viewBarGraph'],
      queryFn: async () => {
        const res = await api.get('/dashboard/daily-share-analytics');
        return res.data;
      },
      enabled,
    });
  };